export default {
  path: '/projectInitiation',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'projectOverview',
      name: 'projectOverview',
      component: () => import('@/pages/purchaseSalesCenter/projectInitiation/index.vue'),
      meta: {
        keepAlive: true,
        title: '项目立项总览',
      },
    },
    {
      path: 'projectCreate',
      name: 'projectCreate',
      component: () =>
        import('@/pages/purchaseSalesCenter/projectInitiation/chengkuang/projectCreate.vue'),
      meta: {
        keepAlive: true,
        title: '新增项目立项',
      },
    },
    {
      path: 'wuMaoProjectCreate',
      name: 'wuMaoProjectCreate',
      component: () =>
        import('@/pages/purchaseSalesCenter/projectInitiation/wumao/components/Project/index.vue'),
      meta: {
        keepAlive: true,
        title: '新增项目立项',
      },
    },
    {
      path: 'wuMaoProjectDetail',
      name: 'wuMaoProjectDetail',
      component: () =>
        import('@/pages/purchaseSalesCenter/projectInitiation/wumao/components/Project/detail.vue'),
      meta: {
        keepAlive: true,
        title: '项目立项详情',
      },
    },
    {
      path: 'wuMaoProjectChange',
      name: 'wuMaoProjectChange',
      component: () =>
        import(
          '@/pages/purchaseSalesCenter/projectInitiation/wumao/components/projectChange/index.vue'
        ),
      meta: {
        keepAlive: true,
        title: '项目变更历史记录',
      },
    },
  ],
};
